<template>
  <div id="ecommerce-receipt" class="ecommerce-receipt">
    <transition type="fade" mode="out-in">
      <div
        id="main"
        class="card receipt-card contentBackground"
        v-if="!formSubmitted"
        key="1"
      >
        <div class="card-header receipt-card-header">
          <slot name="header">
            <h3 id="ecommerce-receipt-title" class="ecommerce-receipt-title">
              Order Details
            </h3>
          </slot>
        </div>
        <div class="card-body receipt-card-body">
          <div class="order-info-row row no-gutters">
            <div class="col-md-6 order-info-col">
              <p class="receipt-label">Order Number:</p>
              <p class="receipt-value order-number">{{ order.id }}</p>
              <p class="receipt-label">Contact Info:</p>

              <template v-if="itemizedReceipt.userInfo">
                <p class="receipt-value contact-info">
                  {{ itemizedReceipt.userInfo.first_name }}
                  {{ itemizedReceipt.userInfo.last_name }}
                </p>
                <p class="receipt-value contact-email">
                  {{ itemizedReceipt.userInfo.email }}
                </p>
              </template>
              <template v-else>
                <p class="receipt-value contact-info">N/A</p>
              </template>
            </div>
            <div class="col-md-6 order-info-col"></div>
          </div>
          <div
            id="refund-info"
            class="mb-5 mt-3 refund-info"
            v-if="requestMode"
          >
            <div v-if="currentEvent.attendee_request_instructions" v-html="currentEvent.attendee_request_instructions">
            </div>
            <template v-else>
              <div class="refund-info-title-wrapper">
                <h5 class="refund-info-title-text receipt-label">
                  If you would like to make a change to your ticket, please select below and specify your request.
                </h5>
              </div>
              <div class="refund-info-desc">
                <p class="mb-0 refund-info-desc-text">
                  Select from the dropdown menu to request a full refund, partial refund, or to transfer your ticket to another attendee.
                </p>
                <p class="mb-0 refund-info-desc-text">
                  If you have a request that is not listed, select other and describe your request.
                </p>
                <small>***Please refer to your event refund policy for any details or restrictions</small>
              </div>
            </template>
          </div>

          <div
            class="itemized-receipt-wrapper itemized-receipt mt-4 collapses-wrapper"
          >
            <div
              class="row itemized-receipt-row pos-item-row no-gutters"
              v-for="(item, index) in itemizedReceipt.posItemTable"
              :key="index"
              :class="
                item.sale_item_discount_codes &&
                item.sale_item_discount_codes.length > 0
                  ? 'bulk-ticketing-sale-item'
                  : ''
              "
            >
              <!-- <code><pre>{{ JSON.stringify(item, null, 2) }}</pre></code> -->
              <div class="itemized-receipt-col col-md-9 col-xs-8">
                <div class="input-group">
                  <div
                    v-if="requestMode"
                    class="input-group-prepend align-items-start mr-2"
                    title="Cancel the existing request to make a new one"
                  >
                    <input
                      :disabled="hasExistingRequest(item)"
                      :id="'pos-item-' + item.sale_item_id"
                      type="checkbox"
                      :value="item.sale_item_id"
                      class="mt-2 item-request-checkbox form-control"
                      v-model="selectedPosItems"
                      aria-label="Click Here to make a request"
                    />
                  </div>
                  <label
                    :for="'pos-item-' + item.sale_item_id"
                    class="sale-item-info sale-item"
                  >
                    <p class="receipt-label sale-item-title sale-item-title">
                      {{ item.sale_item_name }}
                    </p>
                    <p
                      class="receipt-value sale-item-desc mb-0 sale-item-description"
                    >
                      {{ item.sale_item_description }}
                    </p>
                  </label>
                </div>
              </div>
              <div class="itemized-receipt-col col-md-3 col-xs-4">
                <p class="receipt-label float-right sale-item-price">
                  ${{ item.sale_item_price }} USD
                </p>
              </div>
              <div
                class="itemized-receipt-col bulk-discount-code-container col-sm-12"
                v-if="
                  item.sale_item_discount_codes &&
                  item.sale_item_discount_codes.length > 0
                "
              >
                <div :id="'itemized-accordian-' + index" class="accordion-item">
                  <div class="card discount-code-card m-0 p-0">
                    <div
                      class="card-header discount-code-card-header m-0 p-0"
                      :id="'itemized-heading-' + index"
                    >
                      <button
                        class="theme-event-bg-color theme-event-bg-text-color collapsed view-discount-codes-button"
                        tabindex="0"
                        type="button"
                        data-toggle="collapse"
                        :data-target="'#itemizedCollapse-' + index"
                        aria-expanded="false"
                        :aria-controls="'itemizedCollapse-' + index"
                        v-on:click="toggleIcon(index)"
                        :disabled="isAnimating[index]"
                      >
                        <i
                          class="mr-1 theme-event-bg-text-color"
                          :class="{
                            'fas fa-chevron-down': !expanded[index],
                            'fas fa-chevron-up': expanded[index]
                          }"
                        ></i>
                        View Discount Codes
                      </button>
                    </div>
                    <div
                      :id="'itemizedCollapse-' + index"
                      class="collapse discount-code-collapse theme-event-bg-color"
                      :data-index="index"
                      :aria-labelledby="'itemized-heading-' + index"
                      :data-parent="'#itemized-accordian-' + index"
                    >
                      <div class="float-right mt-2 mr-2">
                        <div class="copy-to-clipboard-coups-button-wrapper">
                          <button
                            class="copy-to-clipboard-coups-button"
                            v-on:click="copyAllToClipboard(item, $event)"
                          >
                            Copy to Clipboard
                            <i class="fas fa-copy mr-1"></i>
                            <div class="custom-tooltip" aria-hidden="true">
                              Copied!
                            </div>
                          </button>
                        </div>
                        <button
                          class="export-coups-button"
                          v-on:click="exportCoupons(item)"
                        >
                          Export
                          <i class="fas fa-download mr-1"></i>
                        </button>
                      </div>
                      <div class="card-body discount-code-collapse-card">
                        <div
                          class="receipt-label discount-code-label mt-0 pt-0"
                        >
                          Discount Code<span
                            v-if="item.sale_item_discount_codes.length > 1"
                            >s</span
                          >:
                        </div>
                        <div
                          class="itemized-discount-code-wrapper d-flex flex-wrap"
                        >
                          <button
                            class="receipt-value discount-code-value theme-content-bg-color"
                            tab-index="0"
                            v-for="(
                              code, codeIndex
                            ) in item.sale_item_discount_codes"
                            :key="index + '-' + codeIndex"
                            v-on:click="copySingleCodeToClipboard(code, $event)"
                          >
                            {{ code.code_slug }}
                            <div class="custom-tooltip" aria-hidden="true">
                              Copied!
                            </div>
                          </button>
                        </div>
                        <div class="coupon-instructions">
                          Enter codes at checkout. Only 1 code can be used at a
                          time, and each code can be used
                          {{
                            item.sale_item_discount_codes &&
                            item.sale_item_discount_codes.length > 0
                              ? item.sale_item_discount_codes[0].use_count
                              : 0
                          }}
                          times.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="request-form-section col-xs-12 col-md-9">
                <EcommerceReceiptRequestForm
                  :form.sync="requestForms[item.sale_item_id]"
                  :error="errors[item.sale_item_id]"
                  v-if="
                    requestMode && selectedPosItems.includes(item.sale_item_id)
                  "
                  class="request-form"
                  :current-event="currentEvent"
                ></EcommerceReceiptRequestForm>
                <div
                  v-else-if="requestForms[item.sale_item_id]"
                  class="d-flex request-form-status"
                >
                  <p class="status-text">{{ getStatus(item) }}</p>
                  <a
                    class="ml-3 cancel-request-text"
                    v-if="hasPendingRequest(item)"
                    @click="cancelRequest(getRequestFromSaleItem(item))"
                    ><i class="fas fa-times-circle cancel-request-icon"></i>
                    Cancel Request</a
                  >
                  <div
                    class="row input-error ml-1"
                    v-if="errors && errors[item.sale_item_id]"
                  >
                    <p class="text-danger">@{{ errors[item.sale_item_id] }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="row no-gutters itemized-receipt-row subtotal-row mt-5 mb-3"
            >
              <div class="subtotal-column title col-md-10">
                <p class="receipt-label subtotal-title">Subtotal</p>
              </div>
              <div class="subtotal-column value col-md-2">
                <p class="receipt-label float-right subtotal-amount">
                  {{ itemizedReceipt.subtotal }} USD
                </p>
              </div>
            </div>
            <div class="coupon-section">
              <div
                class="discount-title-wrapper d-flex justify-content-between"
              >
                <p class="receipt-label discount-title">Discounts Applied:</p>
              </div>
              <div class="coupon-item-wrapper">
                <div
                  class="coupon-item d-flex justify-content-between"
                  v-for="(coupon, index) in itemizedReceipt.couponTable"
                  :key="coupon.coupon_code_slug"
                >
                  <p class="code-slug mb-0 coupon-code">
                    {{ coupon.coupon_code_slug }}
                  </p>
                  <p class="code-total discount-color mb-0 coupon-discount">
                    -{{ coupon.coupon_discount_total | formatDollar }}
                  </p>
                </div>
              </div>
            </div>

            <hr />

            <div class="row itemized-receipt-row total-row no-gutters">
              <div class="total-column total-column-label col-md-10">
                <p class="receipt-label total-text">Total</p>
              </div>
              <div class="total-column total-column-amount col-md-2">
                <p class="receipt-label float-right total-value">
                  {{ itemizedReceipt.amount }} USD
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer receipt-card-footer">
          <div class="float-right">
            <button
              class="btn btn-primary"
              v-on:click="saveRequests"
              :disabled="saving"
              v-if="requestMode"
            >
              Submit Request
            </button>
          </div>
          <div class="float-right receipt-action-toggle-wrapper">
            <button
              class="btn btn-secondary receipt-action-toggle-btn"
              v-show="!requestMode"
              v-on:click="toggleRequestMode"
            >
              <span class="request-button-text request-mode-disabled"
                >Request a Change</span
              >
            </button>
            <button
              class="btn btn-secondary receipt-action-toggle-btn mr-2"
              v-show="requestMode"
              v-on:click="toggleRequestMode"
            >
              <span class="request-button-text request-mode-disabled"
                >Cancel Request</span
              >
            </button>
          </div>
        </div>
      </div>
      <div class="card submitted-card" v-else key="2">
        <div class="card-header">
          <h3 class="text-center">Your request has been submitted.</h3>
        </div>
        <div class="card-body">
          <template v-if="hasTransfers">
            <p class="text-center">
              You will receive an email confirmation shortly.
            </p>

            <div class="text-center">
              <div class="order-history__back-button py-4">
                <a id="back-button" @click="formSubmitted = false">
                  <i class="fas fa-arrow-left"></i>
                  {{ lang.get('event_strings.back_button') }}
                </a>
              </div>
              <a class="resend-email not-sent-yet" v-on:click="resendEmail"
                >Didn't receive an email? Resend Email</a
              >
              <p
                class="resend-email resent-message"
                :style="{ opacity: resentEmail == true ? 1 : 0 }"
              >
                Email resent.
              </p>
            </div>
          </template>
          <template v-else>
            <p class="text-center">
              We will review your request and someone will be in touch with you
              soon.
            </p>
          </template>
        </div>
      </div>
    </transition>
    <div
      class="modal fade"
      id="requestModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="requestModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="requestModalLabel">
              Transfer Request Verified
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Your request to transfer your ticket has been verified, we will
              begin processing your request.
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import EcommerceReceiptRequestForm from './EcommerceReceiptRequestForm.vue';
export default {
  data: () => {
    return {
      requestMode: false,
      selectedPosItems: [],
      requestForms: {},
      errors: {},
      formSubmitted: false,
      hasTransfers: false,
      previousTransferRequests: [],
      resentEmail: false,
      expanded: {},
      isAnimating: {},
      saving: false,
      existingRequestsLocal: []
    };
  },
  components: {
    EcommerceReceiptRequestForm
  },
  props: {
    itemizedReceipt: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      required: true
    },
    existingRequests: {
      type: Array,
      required: true
    },
    currentEvent: {
      type: Object,
      required: true
    },
    showVerificationMessage: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.initRequestForms();
  },
  mounted() {
    if (this.showVerificationMessage) {
      $('#requestModal').modal('show');
    }
    this.$nextTick(() => {
      this.addCollapseEventListeners();
    });
  },
  filters: {
    formatDollar: function (value) {
      return '$' + parseFloat(value).toFixed(2) + ' USD';
    }
  },
  watch: {
    existingRequests: {
      handler: function () {
        this.existingRequestsLocal = [...this.existingRequests];
        this.initRequestForms();
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    initRequestForms() {
      this.requestForms = {};
      // Generate the request forms from the existing requests
      for (let i of this.existingRequestsLocal) {
        this.requestForms[i.event_pos_item_id] = i;
      }
    },
    /** capitalize every word in a string, lowercase the rest, remove _ replace with space **/
    formatStatus(status) {
      return status
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');
    },
    getStatus(item) {
      if (
        this.requestForms[item.sale_item_id] &&
        this.requestForms[item.sale_item_id].id
      ) {
        let type = this.requestForms[item.sale_item_id].type;
        if (type) {
          //capitalize the first letter, lower the rest
          type = this.formatStatus(type);
        }
        let status = this.requestForms[item.sale_item_id].status;
        if (status) {
          // capitalize the first letter, lower the rest
          status = this.formatStatus(status);
        }
        return type + ' ' + status;
      }
      return;
    },

    /**
      loop through the selectedPosItems to find the requests that need to be saved.
      the requestForm's keys are the event_pos_item_id's in selectedPosItems.
      we'll make a single request to save or update all the requests.
    **/
    saveRequests() {
      let self = this;
      const attendeeRequests = [];
      if (this.saving) {
        return;
      }
      for (let i of this.selectedPosItems) {
        let request = this.requestForms[i];
        if (request) {
          // if the request has an id, it's an existing request
          if (request.id) {
            // * can't edit
            continue;
          } else {
            if (!request.reason || !request.type) {
              this.errors = Object.assign({}, this.errors, {
                [i]: 'Please fill out the reason and type for the request'
              });
              continue;
            } else {
              delete this.errors[i];
              // reassigning the errors object to trigger a re-render
              this.errors = Object.assign({}, this.errors);
            }

            let eventPosItem = this.itemizedReceipt.posItemTable.find(
              item => item.sale_item_id == i
            );
            // if the request doesn't have an id, it's a new request
            attendeeRequests.push({
              event_id: this.order.event_id,
              event_attendee_id: this.order.event_attendee_id,
              ecommerce_order_id: this.order.id,
              event_pos_item_id: i,
              reason: request.reason,
              type: request.type,
              event_attendee_transaction_id: eventPosItem.event_attendee_transaction_id
            });
          }
        }
      }
      if (Object.keys(this.errors).length > 0) {
        return;
      }
      this.errors = {};

      let route = `/attendee-order-requests`;
      Http.makeRequest(
        'POST',
        route,
        { items: attendeeRequests, ecommerce_order_id: this.order.id },
        response => {
          self.existingRequestsLocal.push(...response.orderRequests);
          self.requestForms = Object.assign({}, self.requestForms);
          self.initRequestForms();
          self.selectedPosItems = [];
          self.requestMode = false;
          self.formSubmitted = true;
          // filter for transfer requests
          let transferRequests = response.orderRequests.filter(
            i => i.type == 'TRANSFER'
          );
          self.previousTransferRequests = transferRequests;
          self.hasTransfers = transferRequests.length > 0;
          self.saving = false;
          EventBus.$emit('saved', { items: attendeeRequests });
          if (!self.hasTransfers) {
            setTimeout(() => {
              self.formSubmitted = false;
            }, 3000);
          }
        },
        error => {
          self.saving = false;
          console.log(error);
        }
      );
    },
    toggleIcon(index) {
      this.$set(this.expanded, index, !this.expanded[index]);
    },
    animationStart(index) {
      this.isAnimating = Object.assign({}, this.isAnimating, { [index]: true });
    },
    animationEnd(index) {
      this.isAnimating = Object.assign({}, this.isAnimating, {
        [index]: false
      });
    },
    hasExistingRequest(item) {
      return this.existingRequestsLocal.find(
        i => i.event_pos_item_id == item.sale_item_id
      );
    },
    hasPendingRequest(item) {
      return this.existingRequestsLocal.find(
        i => i.event_pos_item_id == item.sale_item_id && i.status == 'PENDING'
      );
    },
    getRequestFromSaleItem(item) {
      return this.existingRequestsLocal.find(
        i => i.event_pos_item_id == item.sale_item_id
      );
    },
    cancelRequest(item) {
      let self = this;
      let route = Routes.cancelRequest({id: item.id});
      Http.makeRequest(
        'PUT',
        route,
        {},
        response => {
          self.existingRequestsLocal = self.existingRequestsLocal.filter(
            i => i.id != response.orderRequest.id
          );
          self.initRequestForms();
          EventBus.$emit('order-request-cancelled', response.orderRequest);
        },
        error => {
          console.log(error);
          this.$set(
            this.errors,
            item.event_pos_item_id,
            'There was an error cancelling this request'
          );
        }
      );
    },
    resendEmail() {
      let self = this;
      let route = Routes.resendConfirmationEmail;
      const payload = self.previousTransferRequests.map(i => i.id);
      Http.makeRequest(
        'POST',
        route,
        { requests: payload },
        (response => {
          self.resentEmail = true;
          EventBus.$emit('order-request-email-sent', response.orderRequests);
          setTimeout(() => {
            self.resentEmail = false;
          }, 5000);
        },
        error => {
          console.log(error);
        })
      );
    },
    copyToClipboard(code, event) {
      // Create a temporary textarea element
      const textarea = document.createElement('textarea');

      // Set the value of the textarea to the coupon code
      textarea.value = code;

      // Add the textarea element to the DOM
      document.body.appendChild(textarea);

      // Select the text in the textarea
      textarea.select();

      // Copy the text to the clipboard
      document.execCommand('copy');
      EventBus.$emit('coupons-copied', code);
      // Remove the textarea element from the DOM
      document.body.removeChild(textarea);

      if (!event) return true;
      // Show the tooltip
      const tooltip = event.target.querySelector('.custom-tooltip');
      if (tooltip) {
        tooltip.style.opacity = 1;
        setTimeout(() => {
          tooltip.style.opacity = 0;
        }, 1500);
      }

      // Prevent default tooltip behavior
      event.preventDefault();
    },
    copyAllToClipboard(posItem, event) {
      const coupons = posItem.sale_item_discount_codes;
      const content = coupons.map(i => i.code_slug).join('\n');
      this.copyToClipboard(content, event);
    },
    copySingleCodeToClipboard(code, event) {
      this.copyToClipboard(code.code_slug, event);
    },
    addCollapseEventListeners() {
      document
        .querySelectorAll('.collapses-wrapper')[0]
        .querySelectorAll('.collapse')
        .forEach(collapse => {
          $(collapse).on('show.bs.collapse', evt => {
            const index = $(collapse).data('index');
            this.animationStart(index);
            // find closest parent itemized-receipt-row and add expanded class
            $(collapse).closest('.itemized-receipt-row').addClass('expanded');
            EventBus.$emit('show-collapse', index);
          });

          $(collapse).on('hide.bs.collapse', evt => {
            const index = $(collapse).data('index');
            this.animationStart(index);
            // find closest parent itemized-receipt-row and remove expanded class
            $(collapse)
              .closest('.itemized-receipt-row')
              .removeClass('expanded');
            EventBus.$emit('hide-collapse', index);
          });

          $(collapse).on('shown.bs.collapse', evt => {
            const index = $(collapse).data('index');
            this.animationEnd(index);
            EventBus.$emit('shown-collapse', index);
          });

          $(collapse).on('hidden.bs.collapse', evt => {
            const index = $(collapse).data('index');
            this.animationEnd(index);
            EventBus.$emit('hidden-collapse', index);
          });
        });
    },

    exportCoupons(posItem) {
      const coupons = posItem.sale_item_discount_codes;
      if (!coupons || !coupons.length) return;

      const csvData = [['Coupon Code']];
      const filename = this.generateFilename(
        posItem.sale_item_name ?? 'coupons'
      );
      coupons.forEach(coupon => {
        csvData.push([coupon.code_slug]);
      });
      const csvContent = csvData.map(row => row.join(',')).join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      EventBus.$emit('coupons-exported', posItem);
    },

    generateFilename(saleItemName) {
      let filename = saleItemName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
      return filename + '_coupon_codes.csv';
    },
    toggleRequestMode() {
      this.requestMode = !this.requestMode;
      this.$nextTick(() => {
        EventBus.$emit('toggle-request-mode', this.requestMode);
      });
    }
  }
};
</script>


<style>
/* General Styles */

.discount-color {
  color: #3ea522;
}

.coupon-item p {
  font-size: 1.2em;
}

.contact-info {
  margin-bottom: 0;
}

.card-header,
.card {
  background-color: var(--theme-content-bg-color);
  border: none;
}

/* Receipt Styles */

.receipt-label {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 0.1em;
  margin-top: 0.6em;
}

.receipt-value {
  font-style: thin;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 0.1em;
  position: relative;
}

.resent-message {
  color: #02bf02;
  font-style: italic;
}

/* Discount Code Styles */

.receipt-value.discount-code-value {
  align-self: center;
  border-radius: 6px;
  color: var(--theme-link-color);
  font-size: 18px;
  font-weight: 700;
  margin: 0.5em 1em 0.5em 0;
  padding: 0.5em;
  border: none;
}

.receipt-label.discount-code-label {
  align-self: center;
}

@media only screen and (max-width: 768px) {
  .receipt-value.discount-code-value {
    font-size: 1rem;
    margin: 0.25em;
    padding: 0.25em;
  }
}

@media only screen and (max-width: 576px) {
  .receipt-value.discount-code-value {
    font-size: 0.9rem;
    margin: 0.1em;
    padding: 0.1em;
  }
}

/* Export button Styles */

.export-coups-button,
.export-coups-button i,
.copy-to-clipboard-coups-button,
.copy-to-clipboard-coups-button i {
  background-color: transparent;
  color: var(--theme-link-color);
  border: none;
}

/* Custom Tooltip Styles */

.custom-tooltip {
  background-color: #000;
  border-radius: 6px;
  left: 50%;
  opacity: 0;
  padding: 5px;
  position: absolute;
  top: -25px;
  transform: translateX(-50%);
  transition: opacity 0.3s;
}

button.view-discount-codes-button {
  border: none;
  height: 4em;
  left: 0;
  padding: 1em;
  padding-left: 1.5em;
  position: absolute;
  top: 0;
}

/* Discount Code Collapse Styles */

.discount-code-collapse-card {
  margin-top: 3em;
}

.discount-code-card {
  position: relative;
}

.discount-code-card-header {
  background-color: transparent;
  z-index: 1;
}

.bulk-discount-code-container {
  margin-top: 1em;
}

button.theme-event-bg-text-color:not(.dropdown-toggle) * {
  color: var(--theme-event-bg-text-color);
}

/* POS Item Row Styles */

.pos-item-row {
  margin-bottom: 1em;
  transition: all 0.5s ease;
}

.pos-item-row.expanded {
  margin-bottom: 0.1em;
}

.bulk-ticketing-sale-item .request-form-section {
  margin-bottom: 1em;
  margin-top: 4em;
  transition: margin-top 0.5s ease;
}

.bulk-ticketing-sale-item.pos-item-row.expanded .request-form-section {
  margin-top: 1em;
}
.bulk-ticketing-sale-item.pos-item-row.expanded .request-form-section {
  margin-top: 1em;
}

/* Transition Effects */

.v-enter-active,
.v-leave-active {
  transition: opacity 0.25s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.ecommerce-receipt-title {
  font-size: 24px;
  font-weight: 700;
}

#ecommerce-receipt input.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.copy-to-clipboard-coups-button-wrapper {
  position: relative;
  display: inline-block;
}
</style>
